// data/excuses.js
const excuses = {
    work: [
        "My cat’s hosting a 24-hour hackathon… with my code.",
        "Trapped in a never-ending meeting vortex, send help.",
        "Coffee machine broke, my soul followed suit.",
        "Keyboard’s only typing emoji. 🥴",
        "AI assistant’s running the show now. I'm just here for the ride.",
        "The server's in a spa day, no one told me.",
        "Got lost in the cloud, now I'm drowning in Wi-Fi signals.",
        "My IP address got ghosted by the internet.",
        "Debugging time-space paradoxes, send me a manual.",
        "My computer’s on strike, demanding more RAM and less lag.",
        "Printed my code... now it’s on paper and lost forever.",
        "Waiting on the code to compile like I’m waiting for my fate.",
        "My mouse is on a spiritual journey, can't click.",
        "Brain’s in safe mode, not sure it’s coming back.",
        "The power cut out, but only in my zone of despair.",
        "I’m refactoring my procrastination, it’s a full-time job.",
        "Office chair’s in a loop, my butt’s in a loop, help.",
        "The build server is haunted by lost code.",
        "Accidentally sent my lunch order to the repo. It’s live.",
        "Firewall’s blocking my ability to care."
    ],
    family: [
        "My plant’s having an existential crisis, it’s refusing to grow.",
        "Goldfish is going through a midlife crisis, needs a therapist ASAP.",
        "My cat’s hosting a silent protest against my existence.",
        "Dog tried to fetch the mail… now it’s in the neighbor’s yard.",
        "My hamster’s plotting world domination, I can feel it.",
        "The family’s trying to have a serious conversation, but the parrot’s involved now.",
        "My sibling swapped out my shampoo with maple syrup, revenge is sweet.",
        "Grandma’s TikTok fame is skyrocketing, but I can’t even figure out how to upload a video.",
        "The family dinner turned into a reality show competition for the last piece of pizza.",
        "My dog thinks it’s a cat, now it’s staring at a wall for hours.",
        "My plant’s on a hunger strike because I watered it with tap water.",
        "The cat’s been hiding my socks for weeks, I know it’s personal.",
        "Family game night turned into a full-blown war. We’re all in hiding.",
        "My brother’s creating a cryptocurrency for the family. It’s called ‘Dogecoin 2.0’.",
        "The family pet rabbit has stolen all my socks and is now hoarding them under the couch.",
        "My goldfish is silently judging me, but it’s too late to fix the tank.",
        "Mom’s convinced the Wi-Fi signal is stronger when we all chant in unison.",
        "My dog learned to bark in Morse code, and now I have no idea what it’s trying to say.",
        "The microwave started a rebellion, refusing to cook anything beyond popcorn.",
        "Family photoshoot disaster: My cat made a surprise appearance in every shot."
    ],
    school: [
        "The dog ate my homework… and then uploaded it to the cloud.",
        "Submitted my grocery list instead of the essay, priority shift.",
        "Wi-Fi went to a retreat, no signal, no hope.",
        "My backpack’s in a different dimension, along with my sanity.",
        "Got stuck in a YouTube hole of quantum physics videos.",
        "Alarm clock’s on permanent weekend mode, and so am I.",
        "Aliens abducted me for my math skills, but only for the basics.",
        "Homework’s password-protected. Hack me, please.",
        "Conducting a sleep study, on my own demise.",
        "The school bus took a detour to the Bermuda Triangle, no big deal.",
        "Pencil’s in a creative block, can’t write without feelings.",
        "The printer only prints my existential crisis in hieroglyphics.",
        "Training my goldfish for the Olympics, priorities.",
        "Study notes? They’re now an abstract art piece.",
        "Waiting for inspiration, but it got stuck in traffic.",
        "Power outage fried my brain’s RAM. All memory lost.",
        "Debated philosophy with my textbook... lost.",
        "My computer got a virus, and it’s a pandemic of memes.",
        "Testing if homework self-completes, data’s inconclusive.",
        "My study group was ambushed by a squad of squirrels."
    ]
}

export default excuses

